export type OrderV2Location = {
    id: number;
    name: string;
};

const types = {
    ACCESS_DESTROY_FAILED: "ORDER_V2_PERMISSION/ACCESS_DESTROY_FAILED",
    ACCESS_DESTROY_REQUEST: "ORDER_V2_PERMISSION/ACCESS_DESTROY_REQUEST",
    ACCESS_DESTROY_SUCCESS: "ORDER_V2_PERMISSION/ACCESS_DESTROY_SUCCESS",

    ACCESS_FETCH_FAILED: "ORDER_V2_PERMISSION/ACCESS_FETCH_FAILED",
    ACCESS_FETCH_REQUEST: "ORDER_V2_PERMISSION/ACCESS_FETCH_REQUEST",
    ACCESS_FETCH_SUCCESS: "ORDER_V2_PERMISSION/ACCESS_FETCH_SUCCESS",

    ACCESS_UPDATE_FAILED: "ORDER_V2_PERMISSION/ACCESS_UPDATE_FAILED",
    ACCESS_UPDATE_REQUEST: "ORDER_V2_PERMISSION/ACCESS_UPDATE_REQUEST",
    ACCESS_UPDATE_SUCCESS: "ORDER_V2_PERMISSION/ACCESS_UPDATE_SUCCESS",

    LOCATIONS_FETCH_FAILED: "ORDER_V2_PERMISSION/LOCATIONS_FETCH_FAILED",
    LOCATIONS_FETCH_REQUEST: "ORDER_V2_PERMISSION/LOCATIONS_FETCH_REQUEST",
    LOCATIONS_FETCH_SUCCESS: "ORDER_V2_PERMISSION/LOCATIONS_FETCH_SUCCESS",

    LOCATIONS_ROLES_FAILED: "ORDER_V2_PERMISSION/LOCATIONS_ROLES_FAILED",
    LOCATIONS_ROLES_REQUEST: "ORDER_V2_PERMISSION/LOCATIONS_ROLES_REQUEST",
    LOCATIONS_ROLES_SUCCESS: "ORDER_V2_PERMISSION/LOCATIONS_ROLES_SUCCESS",
};

export default types;
